import { render } from "./OurTeam.vue?vue&type=template&id=3223a49e&scoped=true&ts=true"
import script from "./OurTeam.vue?vue&type=script&lang=ts"
export * from "./OurTeam.vue?vue&type=script&lang=ts"

import "./OurTeam.vue?vue&type=style&index=0&id=3223a49e&scoped=true&lang=css"

import exportComponent from "/builds/otto-tech/otto-financas-site/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3223a49e"]])

export default __exports__